<h3>{{ 'order-details.order-product-discontinuations' | translate }}</h3>
<list-view [selectable]="false">
  <header>{{ 'order-product-discontinuations.product-name' | translate }}</header>
  <header align-right>{{ 'order-product-discontinuations.remainingAmount' | translate }}</header>
  <header align-right>{{ 'order-product-discontinuations.adjustmentAmount' | translate }}</header>
  <row *listData="let discontinuation from discontinuations" [clickable]="editMode" (action)="edit(discontinuation, editorPlacement)" #editorPlacement>
    <column>{{ discontinuation.productPlan | productName }}</column>
    <column [sortValue]="discontinuation.remainingAmount" align-right>{{ discontinuation.remainingAmount | currency }}</column>
    <column [sortValue]="discontinuation.adjustmentAmount" align-right>{{ discontinuation.adjustmentAmount | currency }}</column>
  </row>
</list-view>
<editable-content [offsetPosition]="editorOffsetPosition" #editor *editableData="let edit" (valueChanged)="updateDiscontinuation($event)">
  <edit-content>
    @if (edit.value) {
      <edit-plan-discontinuation [discontinuation]="edit.value" [allDiscontinuations]="discontinuations" [allowedProductPlans]="allowedProductPlans" [companyId]="companyId">
        <button small reject [ignoreValidation]="true" (click)="removeEditingDiscontinuation()"><icon type="xmark" />{{ 'order-product-discontinuations.remove' | translate }}</button>
      </edit-plan-discontinuation>
    }
  </edit-content>
</editable-content>
@if (editMode) {
  <section>
    <button small (click)="addNewDiscontinuation()" [loader]="false"><icon type="plus" />{{ 'order-product-discontinuations.add-new' | translate }}</button>
  </section>
}
